import React from "react";
import Button from '@mui/material/Button';
import { ValidateAccountAdminFuncInput } from "./ValidateAccountAdminFuncInput";

const btnsArray = [{ operation: "Delete" }, { operation: "Cancel" }];

export default function OverviewButtons({
  account,
  navigate,
  _accountExist,
  _createErrorMessage,
  _deleteAccount,
}) {
  const onClick = (operation) => {
    if (operation === "Cancel") {
      let navigationNextUrl = `/AccountOverview`;
      navigate(navigationNextUrl);
      return;
    }

    let validationAccountResult = ValidateAccountAdminFuncInput(
      account,
      _createErrorMessage
    );

    if (!validationAccountResult) {
      return;
    }

    _accountExist({ data: { Id: account } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("59");
        return;
      }
      _deleteAccount({ data: { Id: account } });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => onClick(operation, noValidation, navPath)}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
